// export default CustomerReport;
import React, { useState, useEffect } from "react";
import "../assets/CustomerReport.css";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchCustomers,
  deleteCustomer,
} from "../redux/slices/customerReportSlice";
import { getBranches } from "../redux/slices/CreateCustomerSlice";
import CustomerEditModal from "../modals/CustomerEditModal";
import {
  Download,
  Edit,
  Eye,
  FileSpreadsheet,
  ScanEyeIcon,
  Trash,
} from "lucide-react";
import { toast } from "react-toastify";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import * as XLSX from "xlsx";
import { fetchEmployeeReport } from "../redux/slices/employeeReportSlice";

const CustomerReport = () => {
  const dispatch = useDispatch();
  const { customers, loading, pagination } = useSelector(
    (state) => state.customers,
  );
  const { list: employee } = useSelector((state) => state.employeeReport);

  const { branches } = useSelector((state) => state.customer);

  const [filterType, setFilterType] = useState("userId");
  const [filterValue, setFilterValue] = useState("");
  const [branch, setBranch] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [previewImage, setPreviewImage] = useState(null);
  const [filters, setFilters] = useState({
    customerId: "",
  });
  const [selectedBranch, setSelectedBranch] = useState("");
  const [selectedEmployee, setSelectedEmployee] = useState("");
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(pagination.currentPage);
  const [filterData, setFilterData] = useState("");
  const [company, setCompany] = useState(null);

  const uniqueBranches = [...new Set(customers.map((c) => c.branchId))];

  const superAdminId = Number(localStorage.getItem("adminuserId"));

  useEffect(() => {
    if (!superAdminId) return;
    dispatch(getBranches(superAdminId));
  }, [dispatch, superAdminId]);

  useEffect(() => {
    dispatch(fetchEmployeeReport({ page: 1, pageSize: 100 }));
  }, [dispatch]);

  // useEffect(() => {
  //   dispatch(
  //     fetchCustomers({
  //       page: currentPage,
  //       limit: itemsPerPage,
  //       userId: filters.customerId || undefined,
  //     }),
  //   );
  // }, [dispatch, currentPage, itemsPerPage, filters.customerId]);

  useEffect(() => {
    dispatch(
      fetchCustomers({
        page: currentPage,
        limit: itemsPerPage,
        userId: filters.customerId || undefined,
        // branchId: selectedBranch?.id || undefined,
        employeeId: selectedEmployee?.id || undefined,
      }),
    );
  }, [
    dispatch,
    currentPage,
    itemsPerPage,
    filters.customerId,
    selectedBranch,
    selectedEmployee,
  ]);

  useEffect(() => {
    const fetchCompany = async () => {
      try {
        const response = await fetch(
          `https://payyug.in/api/get-company?superAdminId=${superAdminId}`,
        );
        const data = await response.json();

        if (response.ok && data) {
          // Dynamically construct logo URL
          if (data.logo) {
            data.logoUrl = `https://payyug.in/${data.logo.replace(/^images\//, "")}`;
          }
          setCompany(data);
        } else {
          console.error("Failed to fetch company data");
        }
      } catch (err) {
        console.error("Error fetching company details:", err);
      }
    };

    if (superAdminId) fetchCompany();
  }, [superAdminId]);

  const handleDelete = (id) => {
    if (window.confirm("Are you sure you want to delete this customer?")) {
      dispatch(deleteCustomer(id));
    }
  };

  // const filteredCustomers = customers.filter((customer) => {
  //   // 🔥 Branch filter
  //   if (selectedBranch && customer.branchId !== selectedBranch.id) {
  //     return false;
  //   }

  //   // 🔥 Search filter
  //   if (!filterData) return true;

  //   const search = filterData.toLowerCase();

  //   return (
  //     customer.fullName?.toLowerCase().includes(search) ||
  //     customer.mobileNumber?.includes(search) ||
  //     customer.aadhaarNumber?.includes(search) ||
  //     customer.panNumber?.toLowerCase().includes(search)
  //   );
  // });

  // const handlePageChange = (page) => {
  //   if (page >= 1 && page <= pagination.totalPages) {
  //     dispatch(
  //       fetchCustomers({
  //         page,
  //         limit: currentPage,
  //         userId: filters.customerId || undefined,
  //       }),
  //     );
  //   }
  // };

  const filteredCustomers = customers.filter((customer) => {
    // 1. Branch Filter: Agar select kiya hai aur match nahi hota toh false
    // if (selectedBranch && customer.branchId !== selectedBranch.id) {
    //   return false;
    // }

    // 2. Employee Filter: Agar select kiya hai aur match nahi hota toh false
    // Note: Customer table mein 'createdById' ya 'employeeId' field check karein
    if (selectedEmployee && customer.branchId !== selectedEmployee.id) {
      return false;
    }

    // 3. Search Bar Filter
    if (!filterData) return true;
    const search = filterData.toLowerCase();
    return (
      customer.fullName?.toLowerCase().includes(search) ||
      customer.mobileNumber?.includes(search) ||
      customer.aadhaarNumber?.includes(search) ||
      customer.panNumber?.toLowerCase().includes(search)
    );
  });
  const handlePageChange = (page) => {
    if (page >= 1 && page <= pagination.totalPages) {
      setCurrentPage(page); // 🔥 important
    }
  };

  const handleItemsPerPageChange = (e) => {
    const newLimit = Number(e.target.value);
    setItemsPerPage(newLimit);
    setCurrentPage(1); // 🔥 always reset to first page
  };
  // const superAdminId = localStorage.getItem("adminuserId");
  // const fetchCustomerPhoto = async (userId) => {
  //   try {
  //     if (!userId || customerPhotos[userId]) return;

  //     const res = await fetch(
  //       `https://payyug.in/api/list-kyc?userId=${userId}&superAdminId=${superAdminId}`,
  //     );

  //     if (!res.ok) return;

  //     const data = await res.json();

  //     const photoDoc = data?.documents?.find(
  //       (doc) => doc?.docName?.toLowerCase() === "photo",
  //     );

  //     if (photoDoc?.docImage) {
  //       setCustomerPhotos((prev) => ({
  //         ...prev,
  //         [userId]: `https://payyug.in/uploads/${photoDoc.docImage}`,
  //       }));
  //     }
  //   } catch (err) {
  //     console.error("Photo fetch error:", err);
  //   }
  // };

  const handlepreviewclick = async (userId, branchId) => {
    const superAdminId = localStorage.getItem("adminuserId");
    try {
      const res = await fetch(
        `https://payyug.in/api/list-kyc?userId=${userId}&superAdminId=${superAdminId}&createdId=${branchId}`,
      );
      const data = await res.json();
      if (res.ok && data.documents?.length > 0) {
        const photoDoc = data.documents.find(
          (doc) => doc.docName?.toLowerCase() === "photo",
        );

        // console.log("photoDoc.docImage");
        console.log(photoDoc.docImage);
        if (photoDoc?.docImage) {
          // setPhotoUrl(`https://payyug.in/uploads/${photoDoc.docImage}`);
          setPreviewImage(`https://payyug.in/uploads/${photoDoc.docImage}`);
        }
      } else {
        toast.error("Employee image not Found.");
      }
    } catch (err) {
      console.error("Failed to fetch employee photo:", err);
    }
  };

  //  useEffect(() => {
  //     if (!superAdminId || !customers.length) return;

  //     customers.forEach((c) => {
  //       if (c.userId && !customerPhotos[c.userId]) {
  //         fetchCustomerPhoto(c.userId);
  //       }
  //     });
  //   }, [customers,superAdminId]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

  const exportPDF = async () => {
    const doc = new jsPDF("p", "mm", "a4");
    const pageWidth = doc.internal.pageSize.width;
    const pageHeight = doc.internal.pageSize.height;

    // ================= LOGO =================
    const logoX = 15;
    const logoY = 12;
    const logoSize = 25;
    const logoPadding = 2;

    // Border color & thickness
    doc.setDrawColor(0);
    doc.setLineWidth(0.2);

    // Calculate center of logo
    const centerX = logoX + logoSize / 2;
    const centerY = logoY + logoSize / 2;

    // Radius = half of logo + padding
    const radius = logoSize / 2 + logoPadding;

    // Draw circle
    doc.circle(centerX, centerY, radius);

    // Logo image
    if (company?.logoUrl) {
      try {
        const logoResp = await fetch(company.logoUrl);
        const logoBlob = await logoResp.blob();
        const reader = new FileReader();
        await new Promise((resolve) => {
          reader.onload = () => {
            doc.addImage(
              reader.result,
              "PNG",
              logoX,
              logoY,
              logoSize,
              logoSize,
            );
            resolve();
          };
          reader.readAsDataURL(logoBlob);
        });
      } catch {
        // silent fail
      }
    }

    // ================= COMPANY NAME (AUTO WRAP) =================
    doc.setFont("helvetica", "bold");
    doc.setFontSize(14);

    const nameX = logoX + logoSize + 5;
    const nameY = 18;
    const nameMaxWidth = pageWidth - nameX - 15;

    const companyNameText = doc.splitTextToSize(
      (company?.name || "COMPANY NAME").toUpperCase(),
      nameMaxWidth,
    );

    doc.text(companyNameText, nameX, nameY);

    // Calculate Y after company name
    let currentY = nameY + companyNameText.length * 6;

    // ================= COMPANY DETAILS =================
    doc.setFont("helvetica", "normal");
    doc.setFontSize(11);

    const detailX = nameX;
    const detailMaxWidth = nameMaxWidth;

    // Address
    const addressText = doc.splitTextToSize(
      company?.address || "Company Address",
      detailMaxWidth,
    );
    doc.text(addressText, detailX, currentY);
    currentY += addressText.length * 5;

    // Email
    const emailText = doc.splitTextToSize(
      `Email: ${company?.email || "-"}`,
      detailMaxWidth,
    );
    doc.text(emailText, detailX, currentY);
    currentY += emailText.length * 5;

    // Phone
    const phoneText = doc.splitTextToSize(
      `Phone: ${company?.contact || "-"}`,
      detailMaxWidth,
    );
    doc.text(phoneText, detailX, currentY);
    currentY += phoneText.length * 5;

    // Divider
    doc.line(10, currentY + 4, pageWidth - 10, currentY + 4);

    // ================= REPORT TITLE =================
    doc.setFont("helvetica", "bold");
    doc.setFontSize(13);
    doc.text("Customer Report", pageWidth / 2, currentY + 14, {
      align: "center",
    });

    const tableColumn = [
      "SN",
      "Customer Id",
      "Customer Name",
      "Aadhar Number",
      "Pan Number",
      "Mobile Number",
      "Email",
      "D.O.B",
      "D.O.J",
    ];
    const tableRows = [];

    filteredCustomers.forEach((customer, index) => {
      const customerData = [
        index + 1,
        customer.userId || "N/A",
        customer.fullName || "N/A",
        customer.aadhaarNumber || "N/A",
        customer.panNumber || "N/A",
        customer.mobileNumber || "N/A",
        customer.email || "N/A",
        customer.dateOfBirth
          ? new Date(customer.dateOfBirth).toLocaleDateString("en-GB")
          : "N/A",
        customer.dateOfJoining
          ? new Date(customer.dateOfJoining).toLocaleDateString("en-GB")
          : "N/A",
      ];
      tableRows.push(customerData);
    });

    autoTable(doc, {
      head: [tableColumn],
      body: tableRows,
      startY: currentY + 20,
      theme: "grid",
      styles: {
        fontSize: 7,
        cellPadding: 3,
        halign: "center",
      },
      headStyles: {
        fontStyle: "bold",
        fontSize: 7,
      },
      footStyles: {
        fillColor: [220, 220, 220],
        textColor: 20,
        fontStyle: "bold",
        fontSize: 8,
      },
      alternateRowStyles: {
        fillColor: [245, 245, 245],
      },
    });
    doc.save("CustomerReport.pdf");
  };

  const exportExcel = () => {
    const data = filteredCustomers.map((customer, index) => ({
      SN: index + 1,
      "Customer Id": customer.userId || "N/A",
      "Customer Name": customer.fullName || "N/A",
      "Aadhar Number": customer.aadhaarNumber || "N/A",
      "Pan Number": customer.panNumber || "N/A",
      "Mobile Number": customer.mobileNumber || "N/A",
      Email: customer.email || "N/A",
      "D.O.B":
        new Date(customer.dateOfBirth).toLocaleDateString("en-GB") || "N/A",
      "D.O.J":
        new Date(customer.dateOfJoining).toLocaleDateString("en-GB") || "N/A",
    }));

    const worksheet = XLSX.utils.json_to_sheet(data);

    if (!data.length) {
      toast.error("No data to export");
      return;
    }
    // 🔹 Header styling
    const headerCells = Object.keys(data[0]);
    headerCells.forEach((_, index) => {
      const cellRef = XLSX.utils.encode_cell({ r: 0, c: index });
      worksheet[cellRef].s = {
        font: {
          bold: true,
          color: { rgb: "FFFFFF" },
        },
        fill: {
          fgColor: { rgb: "1F4E78" }, // dark blue
        },
        alignment: {
          horizontal: "center",
          vertical: "center",
        },
      };
    });

    // 🔹 Auto column width
    worksheet["!cols"] = headerCells.map((key) => ({
      wch: Math.max(key.length + 5, 18),
    }));

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Customer Report");

    XLSX.writeFile(workbook, "CustomerReport.xlsx");
  };

  // Generate pagination buttons
  const filteredData = customers;

  const pageNumbers = [];
  for (let i = 1; i <= pagination.totalPages; i++) pageNumbers.push(i);

  return (
    <div className="CustomerReport-container">
      <div className="customer-report-filter-container">
        <h2 className="CustomerReport-heading">Customer Report</h2>
        <div className="customer-report-filter-inputs-section">
          {/* <div className="customer-report-filter-input-filed">
            <label>Select Branch</label>
            <select
              value={selectedBranch?.id || ""}
              onChange={(e) => {
                const branch = branches.find(
                  (br) => br.id === Number(e.target.value),
                );
                setSelectedBranch(branch);
                setCurrentPage(1); // 🔥 important
              }}
            >
              <option value="">All Branches</option>
              {branches.map((b) => (
                <option key={b.id} value={b.id}>
                  {b.name}
                </option>
              ))}
            </select>
          </div>
          <div className="customer-report-filter-input-filed">
            <label>Select Employee</label>
            <select
              value={selectedEmployee?.id || ""}
              onChange={(e) => {
                const emp = employee.find(
                  (em) => em.id === Number(e.target.value),
                );
                setSelectedEmployee(emp);
                setCurrentPage(1); 
              }}
            >
              <option value="">All Employees</option>
              {employee.map((e) => (
                <option key={e.id} value={e.id}>
                  {e.fullName}
                </option>
              ))}
            </select>
          </div> */}
          {/* Branch Filter */}
          <div className="customer-report-filter-input-filed">
            <label>Select Branch</label>
            <select
              value={selectedBranch?.id || ""}
              onChange={(e) => {
                const val = e.target.value;
                const branchObj = branches.find((br) => br.id === Number(val));
                setSelectedBranch(branchObj || ""); // Agar "All" select kiya toh null/empty
                setSelectedEmployee(""); // Branch change hone par employee reset karein
                setCurrentPage(1);
              }}
            >
              <option value="">All Branches</option>
              {branches.map((b) => (
                <option key={b.id} value={b.id}>
                  {b.name}
                </option>
              ))}
            </select>
          </div>

          {/* Employee Filter */}
          <div className="customer-report-filter-input-filed">
            <label>Select Employee</label>
            <select
              value={selectedEmployee?.id || ""}
              onChange={(e) => {
                const val = e.target.value;
                const empObj = employee.find((em) => em.id === Number(val));
                setSelectedEmployee(empObj || "");
                setCurrentPage(1);
              }}
            >
              <option value="">All Employees</option>
              {/* Filter employees based on branch if needed */}
              {employee
                .filter(
                  (emp) =>
                    !selectedBranch || emp.branchId === selectedBranch.id,
                )
                .map((e) => (
                  <option key={e.id} value={e.id}>
                    {e.fullName}
                  </option>
                ))}
            </select>
          </div>
          <div className="customer-report-filter-input-filed">
            <label>Customer Id</label>
            <input
              type="text"
              name="customerId"
              placeholder="Enter customer id"
              value={filters.customerId}
              onChange={handleInputChange}
            />
          </div>
          <div className="customer-report-filter-input-filed">
            <label>Customer Name/Mobile/Adhaar/Pan</label>
            <input
              type="text"
              name="filterData"
              placeholder="Search by Customer Name/Mobile/Adhaar/Pan"
              value={filterData}
              onChange={(e) => setFilterData(e.target.value)}
            />
          </div>
        </div>
      </div>

      <div className="customer-report-downloads-section">
        <div>
          <label>Show </label>
          <select onChange={handleItemsPerPageChange} value={itemsPerPage}>
            <option value="10">10</option>
            <option value="25">25</option>
            <option value="50">50</option>
            <option value="100">100</option>
            <option value="50000">All</option>
          </select>
          <span> entries</span>
        </div>
        <div className="customer-report-download-btns">
          <button onClick={exportExcel}>
            <FileSpreadsheet size={15} /> Excel
          </button>
          <button onClick={exportPDF}>
            <Download size={15} /> Pdf
          </button>
        </div>
      </div>

      {/* Table Section */}
      <div className="CustomerReport-tableWrapper">
        <table className="CustomerReport-table">
          <thead>
            <tr>
              <th>SN</th>
              <th>Image</th>
              <th>User ID</th>
              <th>Emp. search ID</th>
              <th>User Name</th>
              <th>Phone</th>
              <th>Aadhar</th>
              <th>PAN</th>
              <th>Email</th>
              <th>Joining Date</th>
              <th>DOB</th>
              {/* <th>Branch Id</th> */}
              {/* <th>Role</th> */}
              <th>Address</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan="15" style={{ textAlign: "center" }}>
                  Loading...
                </td>
              </tr>
            ) : filteredCustomers.length > 0 ? (
              filteredCustomers.map((row, index) => (
                <tr key={row.id}>
                  <td>
                    {(pagination.currentPage - 1) * pagination.limit +
                      index +
                      1}
                  </td>
                  {/* <td>
                    <img
                      src={`https://ui-avatars.com/api/?name=${encodeURIComponent(
                        row.fullName || ""
                      )}&background=random`}
                      alt="Profile"
                    />
                  </td> */}
                  <td>
                    <button
                      className="preview-btn-emprpt"
                      onClick={() =>
                        handlepreviewclick(row.userId, row.branchId)
                      }
                    >
                      <Eye />
                    </button>
                  </td>

                  <td>{row.userId || "N/A"}</td>

                  <td>{row.branchId || "N/A"}</td>
                  <td>{row.fullName || "N/A"}</td>
                  <td>{row.mobileNumber || "N/A"}</td>
                  <td>{row.aadhaarNumber || "N/A"}</td>
                  <td>{row.panNumber || "N/A"}</td>
                  <td>{row.email || "N/A"}</td>
                  <td>{row.dateOfJoining?.slice(0, 10) || "N/A"}</td>
                  <td>{row.dateOfBirth?.slice(0, 10) || "N/A"}</td>
                  {/* <td>{row.branchName}</td>
                  <td>{row.roleName}</td> */}
                  <td>{row.address || "N/A"}</td>
                  <td>
                    {/* <button
                      className="CustomerReport-edit"
                      onClick={() => {
                        setIsModalOpen(true);
                        setSelectedCustomer(row);
                      }}
                      title="Edit"
                    >
                      <i className="fas fa-edit"></i>
                    </button> */}
                    <button
                      className="edit-icon-customerReport"
                      onClick={() => {
                        setIsModalOpen(true);
                        setSelectedCustomer(row);
                      }}
                    >
                      <Edit size={18} color="green" />
                    </button>
                    <button
                      className="edit-icon-customerReport"
                      onClick={() => {
                        handleDelete(row.id);
                      }}
                    >
                      <Trash size={18} color="red" />
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="15" style={{ textAlign: "center" }}>
                  No records found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      {pagination.totalPages > 1 && (
        <div className="CustomerReport-pagination">
          <button
            onClick={() => handlePageChange(pagination.currentPage - 1)}
            disabled={pagination.currentPage === 1}
          >
            Prev
          </button>

          <span className="CustomerReport-pageIndicator">
            Page {pagination.currentPage} of {pagination.totalPages}
          </span>

          <button
            onClick={() => handlePageChange(pagination.currentPage + 1)}
            disabled={pagination.currentPage === pagination.totalPages}
          >
            Next
          </button>
        </div>
      )}

      {previewImage && (
        <div className="modal-overlay" onClick={() => setPreviewImage(null)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <img src={previewImage} alt="KYC Preview" className="modal-image" />
            <button
              className="modal-close"
              onClick={() => setPreviewImage(null)}
            >
              ×
            </button>
          </div>
        </div>
      )}

      {/* Edit Modal */}
      <CustomerEditModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        customer={selectedCustomer}
      />
    </div>
  );
};

export default CustomerReport;
